import React, { ReactNode } from 'react';
import { I18n } from '@aws-amplify/core';
import { Logo } from '@/components/Layout/Container/Logo';
import { SurveyTitleWrapper, SurveyTitle, Container, Content, MenuBar } from './styles';

interface ContentContainerProps {
	children: ReactNode;
}

export function ContentContainer({ children }: Readonly<ContentContainerProps>) {
	return (
		<Container>
			<MenuBar>
				<Logo />
			</MenuBar>
			<Content>
				<SurveyTitleWrapper>
					<SurveyTitle>{I18n.get('Psychosocial')}</SurveyTitle>
				</SurveyTitleWrapper>
				{children}
			</Content>
		</Container>
	);
}
